import React, { useEffect } from 'react';
import './Cards.css';
import CardItem from './CardItem';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

function Cards() {
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1200, // Animation duration (in ms)
      once: true,     // Run animation only once
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <div 
      className='cards' 
      style={{ paddingRight: '25px' }}
      data-aos="fade-up"         // 👈 AOS animation type
      data-aos-duration="1500"   // Optional custom duration
      data-aos-once="true"       // Runs once per page load
    >
      {/* <h1>Check out these EPIC Destinations!</h1> */}
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/piyush.png'
              text='Some skills that I learned in my free time.'
              label='Skills'
              path='/Skills'
            />
            <CardItem
              src='images/co.jpg'
              text='My Achivements, See my all Achivements.'
              label='Achivements'
              path='/Achivement'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/photo_editing/jalmahal.avif'
              text='My Photo Editing Collection, Visit my Photo Editing collection.'
              label='Photo Editing'
              path='/PhotoEditing'
            />
            <CardItem
              src='images/he.avif'
              text='Hobbies, I like most to do. See my hobbies.'
              label='Hobbies'
              path='/Hobbies'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
